import { BulkSubscription } from '@/pages/bulk-subscriptions/bulk-subscriptions.types';
import { useTranslation } from '@/hooks/useTranslation';
import { BrowseActiveFilter, FILTER_TYPE } from '@/pages/browse/types';

import { matchesAnyText, matchesFilterQuery } from './filterQuery';
import { FilterMenuItem } from './FilterMenuItem';
import { FilterSubmenu } from './FilterSubmenu';

interface FilterListBulkSubscriptionsProps {
    subscriptions: BulkSubscription[];
    query: string;
    onSelect: (type: string, filter: BrowseActiveFilter) => void;
}

export function FilterListBulkSubscriptions({
    subscriptions,
    query,
    onSelect,
}: FilterListBulkSubscriptionsProps) {
    const { t } = useTranslation();

    const matching = subscriptions.filter((subscription) =>
        matchesAnyText(query, subscription.name, subscription.label, String(subscription.id)),
    );
    const headerMatches = matchesFilterQuery(
        t('ITEMS_SEARCH_FILTER.MENU.BULK_SUBSCRIPTIONS'),
        query,
    );
    const visible = headerMatches ? subscriptions : matching;

    return (
        <FilterSubmenu
            label={t('ITEMS_SEARCH_FILTER.MENU.BULK_SUBSCRIPTIONS')}
            query={query}
            matchesQuery={headerMatches}
            hasMatchingChildren={matching.length > 0}
        >
            {visible.map((subscription) => (
                <li key={subscription.id} className="tw-list-none">
                    <FilterMenuItem
                        className="tw-pl-8"
                        onSelect={() => {
                            const displayName = subscription.name || subscription.label;
                            onSelect(FILTER_TYPE.BULK_SUBSCRIPTION, {
                                name: `${displayName} : ${t(`Id.${subscription.id}`)}`,
                                type: FILTER_TYPE.BULK_SUBSCRIPTION,
                                itemsQuery: {
                                    bulkSubscriptionId: String(subscription.id),
                                },
                            });
                        }}
                    >
                        {subscription.name || subscription.label}
                    </FilterMenuItem>
                </li>
            ))}
        </FilterSubmenu>
    );
}
